import React, { Component } from 'react';
import ButtonGroup from 'react-bootstrap/ButtonGroup';
import { Link } from 'react-router-dom';
import { Toast } from 'react-bootstrap';
import { last, toNumber, size, get } from 'lodash';
import NetworkHeartService from 'network-heart-service';
import moment from 'moment';
import { connect } from 'react-redux';
import { storeNRWByDMA } from '../../../redux/general/action';
import nextId from "react-id-generator";


import { getNRWTable } from '../../../api/nrw_table';
import { getToken } from '../../../api/get_token';
import Snipper from '../../layout/Spinner/snipper.component';
import WrapperSearchBoxRealLoss from '../../content/real-loss/wrapper-searchbox-realloss/wrapper-seachbox-realloss.component';
import WrapperWaterBalanceTable from '../../content/real-loss/wrapper-water-balance-table/wrapper-water-balance-table.component';


export class RealLossPage extends Component {

    constructor(props) {
        super(props);

        this.state = {
            // dataNRWByDMA: this.props.dataNRWByDMA ? this.props.dataNRWByDMA.data : {},
            // dataNRWByDMA: {},
            loading: false,
            hasData: true,
            showToast: false,
            textInToast: '',
            failColorToast: '#DCBF85',
            colorToast: '#F5F8DE',
            monthSearch: toNumber(moment(new Date()).format('MM')),
            yearSearch: toNumber(moment(new Date()).format('yyyy'))
        }
        // this.networkHeartService = new NetworkHeartService({
        //     heartMode: 'auto',
        //     reconnect() {
        //       console.log('Network connected again ...')
        //     },
        //     offline() {
        //         console.log('Network go offline ...')
        //       }
        //   });

        //   this.networkHeartService.start();

    }

    closeToast = () => this.setState({ showToast: false });

    opentToast = () => this.setState({ showToast: true });

    searchDMAByMonthYearIDDMA = async (monthSearch, yearSearch, dmaID) => {
        //check network status
        const isOnline = await NetworkHeartService.isOnline();
        if (!isOnline) {
            this.setState({ textInToast: 'Oh, may be you went offline, please check you connection!', colorToast: '#DCBF85' })
            this.opentToast();
            return;
        }

        this.setState({ loading: true });

        const resGetToken = await getToken();
        const token = resGetToken.data.token;
        const whereClause = `DMAID = '${dmaID}' and MONTH = ${monthSearch} and YEAR = ${yearSearch}`;
        const resGetNRWDMA = await getNRWTable(token, whereClause);
        // console.log("resGetNRWDMA: ",resGetNRWDMA);

        
        if (!(Array.isArray(resGetNRWDMA.data.layers[0].features) && resGetNRWDMA.data.layers[0].features.length)) {
            this.props.storeNRWByDMA({});
            this.setState({ hasData: false, loading: false })
            this.setState({ textInToast: 'No data found!', colorToast: '#DCBF85' })
            this.opentToast();
            return;
        }
        
        const lastResultObject = last(resGetNRWDMA.data.layers[0].features).attributes;
        // console.log("lastResultObject: ",lastResultObject);
        this.setState({ loading: false });

        this.props.storeNRWByDMA(lastResultObject);
       
    }

    render() {
        return (
            <div className="wrapper-dashboard-page">
                <h1 className="page-name-header">Real loss</h1>
                {/* <p className="content-test">Lorem ipsum dolor sit amet, consectetur adipiscing elit. ae risus tristique posuere.</p> */}
                <WrapperSearchBoxRealLoss
                    // key={nextId()}
                    searchFromParent={this.searchDMAByMonthYearIDDMA}
                    // monthSearchFromMap={this.props.dataNRWByDMA.MONTH ? this.props.dataNRWByDMA.MONTH : this.state.monthSearch}
                    // yearSearchFromMap={this.props.dataNRWByDMA.YEAR ? this.props.dataNRWByDMA.YEAR : this.state.yearSearch}
                    // dmaidSearchFromMap={this.props.dataNRWByDMA.DMAID ? this.props.dataNRWByDMA.DMAID : ''}
                ></WrapperSearchBoxRealLoss>


                <WrapperWaterBalanceTable
                    dataNRWByDMA={this.props.dataNRWByDMA.data ? this.props.dataNRWByDMA.data : this.props.dataNRWByDMA}></WrapperWaterBalanceTable>

                {/* <WrapperWaterBalanceTable></WrapperWaterBalanceTable> */}


                <div style={{
                    position: 'fixed',
                    bottom: '10px',
                    right: '2px',
                }}>
                    <Toast onClose={this.closeToast} show={this.state.showToast} delay={3000} autohide>
                        <Toast.Header>
                            <img
                                // src="holder.js/20x20?text=%20"
                                className="rounded mr-2"
                                alt=""
                            />
                            <strong className="mr-auto">NRW Management</strong>
                            {/* <small>11 mins ago</small> */}
                        </Toast.Header>
                        <Toast.Body style={{ backgroundColor: `${this.state.colorToast}` }}>{this.state.textInToast}</Toast.Body>
                    </Toast>
                </div>

                {this.state.loading ?
                    (<div style={{
                        position: 'fixed',
                        top: '50%',
                        right: '50%',
                    }}>
                        <Snipper /></div>) : (<></>)}

            </div>



        )
    }
}

const mapStateToProps = state => ({
    dataNRWByDMA: get(state, 'GeneralStore.dataNRWByDMA'),
    searchMonth: get(state,'GeneralStore.searchMonth'),
    searchYear: get(state,'GeneralStore.searchYear'),
    searchDMA: get(state,'GeneralStore.searchDMA'),
})

const mapDispatchToProps = dispatch => {
    return {
        storeNRWByDMA: dataNRWByDMA => {
            dispatch(storeNRWByDMA(dataNRWByDMA))
        }
    }
}

// export default RealLossPage
export default connect(mapStateToProps, mapDispatchToProps)(RealLossPage)
